import { ScrollLottie } from "./ScrollLottie.js"

export function AircraftHead() {
  const body = document.querySelector("body")
  const calcHeight = () => {
    //calculate height of doc less aircraft head offsetTop

    const html = document.documentElement,
      hero = body.querySelector(".hero"),
      craft = body.querySelector("#aircraftHeadContainer"),
      header = body.querySelector("header"),
      footer = body.querySelector("footer"),
      height =
        Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight,
        ) -
        hero.offsetHeight -
        footer.offsetHeight -
        header.offsetHeight

    //set calulated height and top position for psuedo element to cover the page for content
    craft.style.setProperty("--gap", height + "px")
  }

  if (document.querySelector("#aircraftHeadContainer")) {
    calcHeight()
    body.classList.add("has-aircraft-head")

    const fixedHero =
      // check for combination of aircraft head in field items and no featured section
      (body.querySelector(
        ".field__items > .field__item:first-child #aircraftHeadContainer",
      ) ||
        body.querySelector(".hero+.aircraft-head")) &&
      // check for combination of aircraft head adjacent hero and no featured section
      !body.querySelector(".featured-section")

    if (fixedHero) {
      body.classList.add("is-first")
    }

    ScrollLottie({
      target: "#aircraftHeadContainer",
      path: "/themes/intrepid/images/animations/AircraftHead.json", // the path to the animation json
    })

    window.addEventListener("resize", () => {
      calcHeight()
    })
  }
}
